import React from "react";
import Map from "../../components/common/Map";

function Chat() {
  return (
    <section id="contact" className="tc-chat-style1">
      <div className="container">
        <div className="content-map">
          <div className="content">
            <h2 className="xl-text">Contact Us</h2>
            <p className="mb-50">
              Ready to bring your vision to life? Connect with Tameer Builders &
              Developers by email, or a visit to our office. Our team is here to
              discuss your project needs and answer any questions.
            </p>

            <div className="d-flex flex-column gap-3">
              <div className="d-flex fs-6">
                <div>
                  <i
                    className="la la-map-marker fs-4"
                    style={{ color: "var(--color-primary-custom)" }}
                  ></i>
                </div>
                <div className="ps-10">
                  <span className="fw-600 d-block">Address</span>
                  <span>
                    283 Abdel Moneim Riad, Building 2, Al Forsan Compound, Unit
                    2301, Sixth Tourist, Central Axis, 6th of October
                  </span>
                </div>
              </div>

              <div className="d-flex fs-6">
                <div>
                  <i
                    className="la la-envelope fs-4"
                    style={{ color: "var(--color-primary-custom)" }}
                  ></i>
                </div>
                <div className="ps-10">
                  <span className="fw-600 d-block">Email</span>
                  <a href="mailto:info@tameer-egypt.com">
                    info@tameer-egypt.com
                  </a>
                </div>
              </div>
            </div>
          </div>
          <Map />
        </div>
      </div>
      <img src="/home1/assets/img/c_line4.webp" alt="" className="c-line wow" />
    </section>
  );
}

export default Chat;
